<template>
  <router-view></router-view>
</template>

<script>

export default {
  name: 'TolusCGC'
}
</script>

<style lang="scss">
@import './assets/styles/custom.scss';
@import './assets/styles/style.scss';
@import 'bootstrap/scss/bootstrap.scss';
@import 'bootstrap-vue/src/index.scss';

@font-face {
  font-family: "OpenSans-Light";
  src: local("Open-Sans"), url('./assets/fonts/OpenSans/OpenSans-Light.ttf') format("truetype");
}

@font-face {
  font-family: "OpenSans-Regular";
  src: local("Open-Sans"), url('./assets/fonts/OpenSans/OpenSans-Regular.ttf') format("truetype");
}

@font-face {
  font-family: "OpenSans-Bold";
  src: local("Open-Sans"), url('./assets/fonts/OpenSans/OpenSans-Bold.ttf') format("truetype");
}

@font-face {
  font-family: "Montserrat";
  src: local("Montserrat"),   url('./assets/fonts/Montserrat/Montserrat-VariableFont_wght.ttf') format("truetype");
}

@font-face {
  font-family: "EmBauhaus_W00_Regular";
  src: local("EmBauhaus_W00_Regular"),   url('./assets/fonts/EmBauhaus_W00_Regular/EmBauhaus_W00_Regular.ttf') format("truetype");
}


.openSans-light {
  font-family: "OpenSans-Light";
}

.openSans-bold {
  font-family: "OpenSans-Bold";
}

.small-ls {
  letter-spacing: -0.3px;
}

.very-small-ls {
  letter-spacing: -0.36px;
}

.cover {
  object-fit: cover !important;
}

.fa:before,
.fas:before,
.far:before {
  content: "" !important;
}

.fa-lg {
  width: 1.6rem;
  height: 1.6rem;
}

.fa-2x {
  width: 2rem !important;
  height: 2rem !important;
}

.fa-2demi {
  width: 2.5rem;
  height: 2.5rem;
}

.fa-3x {
  width: 3rem;
  height: 3rem;
}

.fa-eye {
  background-image: url('./assets/images/picto-oeil.svg');
  background-size: 100% 100% !important;
}

.bg-grey {
  background-color: #E1E1E1;
}

@media (max-width: 767px) {
  .center {
    max-width: 100%;
    margin-left: auto !important;
    margin-right: auto !important;
  }
}

@media (min-width: 768px) and (max-width: 1399px) {
  .center {
    max-width: 90rem;
    margin-left: auto !important;
    margin-right: auto !important;
  }
}

@media (min-width: 1400px) {
  .center {
    max-width: 93rem;
    margin-left: auto !important;
    margin-right: auto !important;
  }
}

.souligne {
  text-decoration: underline;
}
</style>
